export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1656_.b4437602.jpg";